module.exports = "<div class=\"wrapper {{ class }}\">\n  <input type=\"checkbox\" [(ngModel)]=\"checked\" />\n  <label class=\"toggle\" (click)=\"toggleChecked()\"></label>\n  <div class=\"label\" [ngClass]=\"{'checked': isChecked()}\"><span (click)=\"toggleChecked()\">{{ label }}</span></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/latitude-ui/toggle/toggle.component.html
// module id = ./src/latitude-ui/toggle/toggle.component.html
// module chunks = main